import { render, staticRenderFns } from "./wy-smart-tag-configuration.vue?vue&type=template&id=4b0eb8ae&"
import script from "./wy-smart-tag-configuration.vue?vue&type=script&lang=js&"
export * from "./wy-smart-tag-configuration.vue?vue&type=script&lang=js&"
import style0 from "./wy-smart-tag-configuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports